import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useApi, useWorkspace } from '~/contexts';
import { colors, weights } from '~/styles';

const S = {
  Row: styled.div`
    display: flex;
    gap: 0.375rem;
    padding: 0 0.25rem 0.8125rem;
    flex-wrap: wrap;
  `,

  Pill: styled.button`
    border: 1px dashed ${colors.grey10};
    border-radius: 999rem;
    background: transparent;
    color: ${colors.grey75};
    font-weight: ${weights.medium};
    font-size: 0.75rem;
    padding: 0.375rem 0.625rem;
    cursor: pointer;
    white-space: nowrap;
    height: auto;

    &:hover {
      background: ${colors.grey5};
      color: ${colors.grey75};
    }
  `,
};

export default function Suggestions({ conversationId, onSend }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    api.www
      .workspaces(workspace.id)
      .ai()
      .suggestions()
      .then(({ data }) => setSuggestions(data))
      .catch(() => {});
  }, [api, workspace.id, conversationId]);

  if (!suggestions.length) return null;

  return (
    <S.Row>
      {suggestions.map((s) => (
        <S.Pill key={s} onClick={() => onSend(s)}>
          {s}
        </S.Pill>
      ))}
    </S.Row>
  );
}
